import { render } from "./ImsiDataTable.vue?vue&type=template&id=a2ecc7a0&scoped=true"
import script from "./ImsiDataTable.vue?vue&type=script&lang=js"
export * from "./ImsiDataTable.vue?vue&type=script&lang=js"

import "./ImsiDataTable.vue?vue&type=style&index=0&id=a2ecc7a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2ecc7a0"]])

export default __exports__